import React from 'react';
import {
  Button,
} from 'semantic-ui-react';

const prevButton = (p) => {
  return (
    <Button
      primary
      size="small"
      content="Previous"
      icon="arrow left"
      labelPosition="left"
      fluid
      disabled={p.disabled}
      onClick={p.onClick}
    />
  );
}

const nextButton = (p) => {
  return (
    <Button
      primary
      size="small"
      content="Next"
      icon="arrow right"
      labelPosition="right"
      fluid
      disabled={p.disabled}
      onClick={p.onClick}
    />
  );
}

export {
  prevButton,
  nextButton,
}
